import { FieldKey } from '../../context/field-keys.js';
/**
 * Min-divisible auto-copy (T2.3), consolidated from
 * `src/app/records/controls/common/listeners/availability/avail-space-details-listener.service.ts`
 * (`autoUpdateMinDivisible$`, ~lines 92-110):
 *
 *   available_space → minimum_divisible_surface_area (verbatim copy, NO rounding — the legacy
 *   listener calls `setValue(availableSpace)` directly, no formatNumber pipeline)
 *
 * Guard: the legacy `filter(availableSpace != null && !== '')` — an empty source never fires and
 * never clears the target. The debounce is host plumbing; the companion UOM mirroring
 * (available_space_uom_desc → minimum_divisible_surface_area_uom_desc) is host-owned (T2.7) and
 * deliberately NOT modelled here (rules stay UOM-blind).
 */
export const minDivisibleAreaFromAvailableSpaceRule = {
  id: 'availability.min-divisible-area.from-available-space',
  inputs: [FieldKey.AvailSpaceSize],
  outputs: [FieldKey.AvailMinDivisibleArea],
  formulaVersion: '1.0.0',
  run: ctx => {
    const availableSpace = ctx.get(FieldKey.AvailSpaceSize);
    if (availableSpace == null || availableSpace === '') {
      return;
    }
    ctx.set(FieldKey.AvailMinDivisibleArea, availableSpace);
  }
};
export const availabilityMinDivisibleRules = [minDivisibleAreaFromAvailableSpaceRule];
